import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Laugh, Image as ImageIcon, Gamepad2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Toggle } from "@/components/kit";

const CMDS = [
  { key: "joke", icon: Laugh, label: "/joke", desc: "Pick a category (Programming, Dad, Knock-knock, Pun, General, Spooky, Christmas) or random" },
  { key: "game", icon: Gamepad2, label: "/game [search]", desc: "Browse, search and play 400+ browser games (opens external sites)", flag: true },
  { key: "meme", icon: ImageIcon, label: "/meme [query]", desc: "Random PG-13 GIF from GIPHY with an \u201cAnother one\u201d button" },
];

export const FunCommandsTab = ({ guildId }) => {
  const [mod, setMod] = useState(null);
  useEffect(() => { api.get(`/guilds/${guildId}/modules/fun`).then((r) => setMod(r.data)); }, [guildId]);
  if (!mod) return <p className="text-sm text-zinc-500">Loading…</p>;
  const cmds = mod.config?.commands || [];
  const toggleCmd = (k, on) => setMod({ ...mod, config: { ...mod.config, commands: on ? [...new Set([...cmds, k])] : cmds.filter((c) => c !== k) } });
  const save = async () => {
    try { await api.put(`/guilds/${guildId}/modules/fun`, { enabled: mod.enabled, config: mod.config }); toast.success("Fun commands saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="fun-commands-tab" className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 max-w-2xl">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-head font-semibold">Fun Commands</h3>
          <p className="text-xs text-zinc-500 mt-0.5">Turn the whole module off to disable every fun command on this server.</p>
        </div>
        <div className="flex items-center gap-2 text-sm"><span className="text-zinc-400">Module</span><Toggle testid="fun-enabled" checked={mod.enabled} onChange={(v) => setMod({ ...mod, enabled: v })} /></div>
      </div>
      <div className={`space-y-3 ${mod.enabled ? "" : "opacity-50 pointer-events-none"}`}>
        {CMDS.map((c) => (
          <div key={c.key} className="flex items-center gap-3 bg-black/30 border border-zinc-800 rounded-lg px-4 py-3">
            <c.icon className="w-4 h-4 text-volt shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-mono">{c.label}</div>
              <div className="text-xs text-zinc-500">{c.desc}</div>
            </div>
            <Toggle testid={`fun-cmd-${c.key}`} checked={c.flag ? mod.config?.game_enabled !== false : cmds.includes(c.key)}
              onChange={(v) => (c.flag ? setMod({ ...mod, config: { ...mod.config, game_enabled: v } }) : toggleCmd(c.key, v))} />
          </div>
        ))}
      </div>
      <button data-testid="fun-save" onClick={save} className="mt-5 inline-flex items-center gap-2 bg-volt text-black font-medium text-sm rounded-md px-4 py-2 hover:bg-volt-hover transition-colors">
        <Save className="w-4 h-4" /> Save
      </button>
    </div>
  );
};
